import { render, staticRenderFns } from "./batchform.vue?vue&type=template&id=0d10c878&scoped=true&"
import script from "./batchform.vue?vue&type=script&lang=ts&"
export * from "./batchform.vue?vue&type=script&lang=ts&"
import style0 from "./batchform.vue?vue&type=style&index=0&id=0d10c878&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10c878",
  null
  
)

export default component.exports